
"use strict";
exports.__esModule = true;
exports.path = exports.versions = void 0;
exports.versions = {"codemirror": "5.65.18", "katex": "0.16.21"};
exports.path = __dirname;
